import React, { useEffect, useState } from "react"
import {
    Flex,
    View,
    Checkbox,
    CheckboxGroup,
    Text as SpectrumText,
    TextField,
    TagGroup,
    Item,
    ComboBox,
    Picker,
} from "@adobe/react-spectrum"
import styles from "./AddAlert.module.css"
import DeleteButton from "./DeleteButton"
import AddButton from "./AddButton"
import { notify } from "../constants/constants"

const CustomAttribute = ({
    index,
    state,
    updateAbandonedState,
    addNewCustomAttribute,
    deleteCustomAttribute,
    handleCustomAttributeCheckboxChange,
    adminPermission,
    isEditable,
    operation,
    attributesDropdown
}) => {
    const [attributeDropdown, setAttributeDropdown] = useState([])

    useEffect(() => {
        setAttributeDropdown(attributesDropdown || [])
    }, [attributesDropdown])


    const handleAttributeNameChange = (value, attrIndex) => {
        const newState = { ...state }
        const isDuplicate = newState.customAttributes.some(
            (attr, index) => attr.attributeName === value
        )
        if (isDuplicate) {
            notify("Attribute name already exists", "warn", {
                containerId: "modalToast",
            })
            return
        }
        newState.customAttributes[attrIndex].attributeName = value
        updateAbandonedState(newState)
    }
    const handleAttributeValueChange = (value, attrIndex) => {
        const newState = { ...state }
        newState.customAttributes[attrIndex].attributeValue = value
        updateAbandonedState(newState)
    }

    const handleAttributeValueKeyDown = (event, attrIndex) => {
        if (event.key === "Enter" && event.target.value.trim() !== "") {
            const newState = { ...state }
            const newValue = event.target.value.trim()
            const newItem = {
                // id: newValue,
                name: newValue,
            }
            newState.customAttributes[attrIndex].items.push(newItem)
            newState.customAttributes[attrIndex].attributeValues.push(newValue)
            newState.customAttributes[attrIndex].attributeValue = ""
            updateAbandonedState(newState)
        }
    }

    const handleRemoveTag = (keys, attrIndex) => {
        const newState = { ...state }
        const removedIndices = []
        newState.customAttributes[attrIndex].items = newState.customAttributes[
            attrIndex
        ].items.filter((item, index) => {
            if (keys.has(item.name.toString())) {
                removedIndices.push(index)
                return false
            }
            return true
        })
        newState.customAttributes[
            attrIndex
        ].attributeValues = newState.customAttributes[
            attrIndex
        ].attributeValues.filter((_, index) => !removedIndices.includes(index))
        updateAbandonedState(newState)
    }

    const handleAttributeConditionChange = (value, attrIndex) => {
        const newState = { ...state }
        newState.customAttributes[attrIndex].attributeCondition = value
        updateAbandonedState(newState)
    }

    return (
        <View padding={"0 0 0 3rem"}>
            <View>
                {/* <CheckboxGroup orientation="horizontal"> */}
                   <Checkbox
                        isSelected={state.customAttribute}
                        onChange={handleCustomAttributeCheckboxChange}
                        isDisabled={!isEditable && operation !== "add" || attributeDropdown?.length === 0}                        
                    >
                        <SpectrumText UNSAFE_className={styles.checkbox} >
                            Attributes
                        </SpectrumText>
                    </Checkbox>
                {/* </CheckboxGroup> */}
                {state?.customAttributes?.length &&
                    state?.customAttributes?.map((attr, attrIndex) => (
                        <View
                            marginStart={"2rem"}
                            key={`abc-${attrIndex}`}
                            marginY={"4px"}
                        >
                            <Flex
                                gap={"1rem"}
                                UNSAFE_className={styles.placeholder}
                            >
                                <ComboBox
                                    items={attributeDropdown}
                                    placeholder="Attribute name"
                                    width={"24rem"}
                                    onSelectionChange={(value) =>
                                        handleAttributeNameChange(
                                            value,
                                            attrIndex
                                        )
                                    }
                                    selectedKey={attr.attributeName}
                                    isDisabled={!state.customAttribute || (!isEditable && operation !== "add")}
                                    allowsCustomValue={false}
                                >
                                    {(item) => (
                                        <Item key={item.id}>{item.name}</Item>
                                    )}
                                </ComboBox>
                                <Picker
                                    width={"11rem"}
                                    items={[{id: "E", name: "IN"}, {id: "NE", name: "NOT IN"}, {id: "GE", name: ">="}, {id: "LE", name: "<="}]}
                                    isDisabled={!state.customAttribute || (!isEditable && operation !== "add")}
                                    selectedKey={attr.attributeCondition || "E"}
                                    defaultSelectedKey={attr.attributeCondition || "E"}
                                    onSelectionChange={(value) =>
                                        handleAttributeConditionChange(
                                            value,
                                            attrIndex
                                        )
                                    }
                                >
                                    {(item) => (
                                        <Item key={item.id}>{item.name}</Item>
                                    )}
                                </Picker>

                                <TextField
                                    value={attr.attributeValue}
                                    placeholder="Enter Attribute value and press Enter"
                                    width={"24rem"}
                                    onChange={(value) =>
                                        handleAttributeValueChange(
                                            value,
                                            attrIndex
                                        )
                                    }
                                    onKeyDown={(event) =>
                                        handleAttributeValueKeyDown(
                                            event,
                                            attrIndex
                                        )
                                    }
                                    isDisabled={!state.customAttribute || (!isEditable && operation !== "add")}
                                />
                                <DeleteButton
                                    onClick={() =>
                                        deleteCustomAttribute(attrIndex)
                                    }
                                    isDisabled={
                                        (!isEditable && operation !=="add" ) ||
                                        state.customAttributes.length == 1
                                    }
                                />
                                {attrIndex === 0 && (
                                    <AddButton
                                        isEditable={isEditable}
                                        operation={operation}
                                        onClick={addNewCustomAttribute}
                                    />
                                )}
                            </Flex>
                            {attr?.items?.length > 0 && (
                                <TagGroup
                                    UNSAFE_style={{ overflow: "auto" }}
                                    width={"61rem"}
                                    maxHeight={"10rem"}
                                    items={attr.items}
                                    onRemove={(isEditable || operation==="add") ? (keys) =>
                                        handleRemoveTag(keys, attrIndex) : null
                                    }
                                    aria-label="Removable TagGroup example"
                                >
                                    {(item) => (
                                        <Item key={item.name}>{item.name}</Item>
                                    )}
                                </TagGroup>
                            )}
                        </View>
                    ))}
            </View>
        </View>
    )
}

export default CustomAttribute
